<template>
  <section id="supply-offer-tariffs">
    <header>
      Тарифы
      <VLink material="add" @click="showTariffCard()"> Добавить тариф </VLink>
    </header>

    <VDataGridV2
      class="supply-offer-tariffs-grid fill"
      :data="supplyOffer.sortedTariffs"
      @row:dblclick="(row, index) => showTariffCard(row, index)"
    >
      <VDataGridColumnV2
        id="badge"
        width="34px"
      >
        <template #default="{ row }">
          <VBadge
            v-if="isShowBudgetPriceBadge(row)"
            class="success"
            @mouseenter="$core.tooltip.show($event.currentTarget, 'Бюджетная цена')"
            @mouseleave="$core.tooltip.hide()"
          > Б
          </VBadge>
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2
        id="price"
        label="Цена"
        width="170px"
        content-align="right"
        content-class="ellipsis"
      >
        <template #default="{ row }">
          {{ row.price.format(supplyOffer.currency) }}
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2
        id="qty"
        label="Кол-во"
        width="150px"
        content-align="right"
        content-class="ellipsis"
      >
        <template #default="{ row }">
          от {{ row.qty?.start ?? '--' }} {{ supplyOffer.unit }}
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2 id="date" label="Дата" width="100px">
        <template #default="{ row }">
          <div
            class="grey"
            :class="{ error: row.isExpired }"
            @mouseenter="onMouseEnter(row, $event)"
            @mouseleave="onMouseLeave($event)"
          >
            {{ row.actualFor?.start }}
          </div>
        </template>
      </VDataGridColumnV2>
    </VDataGridV2>
  </section>
</template>

<style lang="scss" src="./SupplyOfferTariffsGrid.scss" />

<script lang="ts">
import VBadgeIcon from '@/lib/components/VBadgeIcon/VBadgeIcon.vue';

import SupplyOffer         from '@/domains/SupplyOffers/SupplyOffer';
import SupplyOffersService from '@/domains/SupplyOffers/SupplyOffersService';
import BudgetPrice         from '@/domains/BudgetPrices/BudgetPrice';
import MoneyUtils          from '@/core/utils/MoneyUtils';

export default defineComponent({
  name: 'SupplyOfferTariffsGrid',

  components: {
    VBadgeIcon,
  },

  props: {
    supplyOffer: {
      type:     Object as PropType<SupplyOffer>,
      required: true,
    },
    budgetPrice: {
      type:    Object as PropType<BudgetPrice | null>,
      default: null,
    },
  },

  emits: [
    'tariff-created',
  ],

  setup() {
    return { SupplyOffersService };
  },

  data() {
    return {
      convertedBudgetPrice: this.$core.utils.cloneDeep(this.budgetPrice),
    };
  },

  watch: {
    budgetPrice: {
      deep:      true,
      immediate: true,
      handler:   'recalculateConvertedBudgetPrice',
    },
    supplyOffer: {
      deep:      true,
      immediate: true,
      handler:   'recalculateConvertedBudgetPrice',
    },
  },

  methods: {
    async recalculateConvertedBudgetPrice(): Promise<void> {
      if (this.$core.utils.isNullOrUndefined(this.budgetPrice?.price) === true) {
        return;
      }

      /** Цена может прийти уже после монтирования — клон в data() сделан по пустому пропу */
      this.convertedBudgetPrice = this.$core.utils.cloneDeep(this.budgetPrice);

      this.convertedBudgetPrice.price = await MoneyUtils.convert(
        this.budgetPrice.price,
        this.budgetPrice.currency!.code,
        this.supplyOffer.currencyCode,
        new Date()
      );
    },

    isShowBudgetPriceBadge(row: any): boolean {
      return this.budgetPrice && this.budgetPrice.price && row.isLessOrEqualBudgetPrice(this.convertedBudgetPrice);
    },

    onMouseEnter(row, $event) {
      if (row.isExpired) {
        this.$core.tooltip.show(
          $event.currentTarget, `Цене больше ${SupplyOffersService.PRICE_EXPIRATION_DAYS} дней`
        );
      }
    },

    onMouseLeave() {
      this.$core.tooltip.hide();
    },

    showTariffCard(tariff = undefined): void {
      this.$core.dialogs.SupplyOfferTariffCard.show(
        {
          supplyOffer: this.supplyOffer,
          tariff:      tariff,
        },
        {
          [SupplyOffer.Events.Updated]: (createdTariff) => {
            this.supplyOffer.addTariff(createdTariff);
            this.$emit('tariff-created');
          },
        },
      );
    },
  },
});
</script>
